import React, { createContext, useContext, ReactNode } from "react";

interface IndexEmailNotificationEventsProviderProps {
  children: ReactNode;
  parentId: string;
}

interface IndexEmailNotificationEventsContextValue {
  parentId: string;
}

const IndexEmailNotificationEventsContext = createContext<
  IndexEmailNotificationEventsContextValue | undefined
>(undefined);

const IndexEmailNotificationEventsProvider: React.FC<
  IndexEmailNotificationEventsProviderProps
> = ({ children, parentId }) => {
  return (
    <IndexEmailNotificationEventsContext.Provider value={{ parentId }}>
      {children}
    </IndexEmailNotificationEventsContext.Provider>
  );
};

const useIndexEmailNotificationEventsContext =
  (): IndexEmailNotificationEventsContextValue => {
    const context = useContext(IndexEmailNotificationEventsContext);
    if (!context) {
      throw new Error(
        "useIndexEmailNotificationEventsContext must be used within an IndexEmailNotificationEventsProvider"
      );
    }
    return context;
  };

export {
  IndexEmailNotificationEventsProvider,
  useIndexEmailNotificationEventsContext,
};
